export default __webpack_public_path__ + "static/media/pj-sexy-api.f07faab1.png";